export default __webpack_public_path__ + "static/ru-3-88b902a0342444f5b6cd0f9a3cc42228.svg";